import Send from "../communication";
import { buildQueryParams } from "../utils/dateUtils";

export const getLevelInteraction = async (scopeId, scopeType, user = "", currentUser) => {
  const queryParams = buildQueryParams(user, false, scopeType, false, currentUser);
  
  const query = `/nps/serviceIndicators/finished/assistance/project/${scopeId}`
  return await Send.get(`${query}`, queryParams);
};